import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    margin: "auto",
    marginTop: "20px",
    minHeight: "10vh",
    width: "90vw",
    verticalAlign: "middle",
    backgroundColor: "#eeeeee",
    boxShadow: "2px 2px 9px rgba(0, 0, 0, 0.25)",
  },
  textContainer: {
    marginLeft: "2em",
    wordWrap: "normal",
  },
  paragraph: {
    fontFamily: "Open Sans",
    fontSize: "14px",
    color: "#2f2f2f",
  },
  button: {
    backgroundColor: "rgb(53, 46, 115)",
    color: "white",
    fontSize: "18px",
  },
  logo: {
    height: "128px",
    width: "128px",
  },
  copyrightText: {
    textAlign: "center",
    fontSize: "10px",
    color: "grey",
    paddingBottom: "10px",
  },
});

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        maxWidth="false"
        className={classes.textContainer}
      >
        <a href="https://michigandaily.com">
          <img
            src={require("../images/TMD.png")}
            className={classes.logo}
            alt="TMD logo"
          />
        </a>
        <Grid>
          <Typography className={classes.paragraph}>
            The Michigan Daily
          </Typography>
          <Typography className={classes.paragraph}>
            420 Maynard Street, Ann Arbor, MI 48105
          </Typography>
          <Typography className={classes.paragraph}>
            (734) 418 - 4115
          </Typography>
        </Grid>
      </Grid>
      <Typography className={classes.copyrightText}>
        Copyright © 2020, all rights reserved
      </Typography>
    </div>
  );
};

export default Footer;
